export default __webpack_public_path__ + "static/media/TwoForOne60s.4dde917f.mp3";